import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isSelling: {
    process: false,
    index: null
  },
  demoProducts: [
    {
      title: 'Individual',
      subtitle: 'Estándar',
      price: 60,
      sku: 'membresia-hc-individual',
      period: 'Mes',
      product_id: 15007,
      payment_period: 'Mensual',
      image: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/ind_b.png'
    },
    {
      title: 'Familiar',
      subtitle: 'Estándar',
      price: 80,
      sku: 'membresia-hc-familiar',
      period: 'Mes',
      product_id: 15006,
      payment_period: 'Mensual',
      image: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/fam_b.png'
    }
  ],
  wpapi: false,
  // eslint-disable-next-line
  stapi: wp_membership_sale.stripe,
  // eslint-disable-next-line
  wpsite: wp_membership_sale,
  axiosConfig: {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
      // 'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xMzguNjguMjQzLjY2XC9tZW1icmVzaWEiLCJpYXQiOjE1MjU5OTI1NjIsIm5iZiI6MTUyNTk5MjU2MiwiZXhwIjoxNTI2NTk3MzYyLCJkYXRhIjp7InVzZXIiOnsiaWQiOiI2ODMifX19.oMNPzGn4xCm12sQV2609eFfAk8JD3wJ_792ydcOOrp0'
    }
  },
  statesUSA: [
    { label: 'Alabama', value: 'AL' },
    // { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    // { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky[E]', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts[E]', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: ' North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    // { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania[E]', value: 'PA' },
    { label: 'Rhode Island[F]', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    // { label: 'Utah', value: 'UT' },
    // { label: 'Vermont', value: 'VT' },
    { label: 'Virginia[E]', value: 'VA' },
    // { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' }
  ]
}

const mutations = {
  SETSELLING (state, object) {
    state.isSelling.process = object.process
    state.isSelling.index = object.index
  },
  WPAPILOAD (state, bolean) {
    state.wpapi = bolean
  },
  SAVEUSERTOMEMORY (state, userdata) {
    state.realuser = userdata
  },
  LOCKFAMILYADD (state, status) {
    state.hasFamilyLimit = status
  }
}

const getters = {
  // currentProduct: state => {
  //   var url = state.route.params.producto // return url
  //   return state.features.filter(feature => feature.mainroute === url)
  // },
  currentUrl: state => state.route.params.producto,
  apiwpGett: state => state.wpapi
}

const actions = {
  initSale ({ commit, dispatch }, { self, payload, action }) {
    if (action === 'set' && payload) {
      Vue.localStorage.set('isSellling', JSON.stringify(payload))
      commit('SETSELLING', payload)
    } else if (action === 'clear') {
      Vue.localStorage.remove('isSellling')
      commit('SETSELLING', {
        process: false,
        index: null
      })
    } else if (action === 'recover') {
      let isSellinLS = Vue.localStorage.get('isSellling')
      if (isSellinLS) {
        commit('SETSELLING', JSON.parse(isSellinLS))
      }
    }
  },
  setStep ({ commit, dispatch }, { self, payload, action }) {
    if (action === 'set' && payload) {
      commit('SET_STEP_SALE', payload)
    } else if (action === 'clear') {
      commit('SET_STEP_SALE', payload)
    } else if (action === 'recover') {
      commit('SET_STEP_SALE', payload)
    }
  },
  setAPI ({ commit }, payload) {
    commit('WPAPILOAD', payload)
  },
  getUserData ({ commit, dispatch }, { self }) {
    // Make a request for a user with a given ID
    Vue.axios.get('hclub/app/v1/membership', state.axiosConfig).then(function (response) {
      // console.log('Trae info del usuario -->', response)
      commit('SAVEUSERTOMEMORY', response.data)
      self.filterUsers()
      dispatch('checkFamilyLimit')
    }).catch(function (error) {
      console.log(error)
      console.log(error.statusText)
    })
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js